import { render, staticRenderFns } from "./linkData.vue?vue&type=template&id=7fe7f828&scoped=true"
import script from "./linkData.vue?vue&type=script&lang=js"
export * from "./linkData.vue?vue&type=script&lang=js"
import style0 from "./linkData.vue?vue&type=style&index=0&id=7fe7f828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7f828",
  null
  
)

export default component.exports